import { render, staticRenderFns } from "./receiveCoupon.vue?vue&type=template&id=cf092c4a&scoped=true&"
import script from "./receiveCoupon.vue?vue&type=script&lang=js&"
export * from "./receiveCoupon.vue?vue&type=script&lang=js&"
import style0 from "./receiveCoupon.vue?vue&type=style&index=0&id=cf092c4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf092c4a",
  null
  
)

export default component.exports